import { useEffect, useState } from 'react'
import { useForm } from 'react-final-form'
import { deleteDentalFormClaim } from '../../services/userService'

interface FormAPIHelperProps {
    shouldReset?: boolean
}

const FormAPIHelper = (props: FormAPIHelperProps) => {
    const form = useForm()
    const [shouldCallReset, setShouldCallReset] = useState(false)

    useEffect(() => {
        props.shouldReset && setShouldCallReset(true)
    }, [props.shouldReset])

    useEffect(() => {
        if (!shouldCallReset) return
        form.reset()
        deleteDentalFormClaim()
        setShouldCallReset(false)
    }, [shouldCallReset])

    return <></>
}

export default FormAPIHelper
